/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignScrapeOnExistingCampaignPathParams,
	CampaignScrapeOnExistingCampaignRequest,
	CampaignScrapeOnExistingCampaignResponse,
} from '../types/CampaignScrapeOnExistingCampaign'

/**
 * PATCH /campaigns/:campaign/scrape
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::scrapeOnExistingCampaign
 */
export async function campaignScrapeOnExistingCampaign(
	campaign: CampaignScrapeOnExistingCampaignPathParams['campaign'],
	data: CampaignScrapeOnExistingCampaignRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignScrapeOnExistingCampaignResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/scrape`, data, config)
}
